import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Grid } from '@mui/material'

import BaseDialog from '../../BaseDialog'

import { useDataApi } from '../../../context/DataApiContext'
import { useNotificationsProvider } from '../../../context/NotificationsContext'

export default function CreateEmailDialog({ open, onClose, onCreated }) {
  const { t } = useTranslation()

  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [email, setEmail] = useState('')

  const resource = 'emails'

  const resetState = () => {
    // Clean form
    setLoading(false)
    setError('')
    setEmail('')
  }

  const onCloseDialog = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      onClose()
    } else {
      resetState()
      onClose()
    }
  }

  const onConfirm = () => {
    if (email.length === 0) {
      setError('email_required')
      return
    }

    const body = {
      data: {
        email,
      },
    }

    setLoading(true)
    dataProvider
      .post(resource, body)
      .then(() => {
        dataProvider.cache.reset()
        showNotification('success', t('create-email-dialog.success'))
        onCreated()
        resetState()
      })
      .catch((err) => {
        if (err.response.data.error === 'EMAIL_ALREADY_EXISTS') {
          showNotification(
            'error',
            t('create-email-dialog.already-exists-error')
          )
        } else {
          showNotification('error', t('errors.api-error'))
        }

        setLoading(false)
      })
  }
  return (
    <BaseDialog
      open={open}
      onClose={onCloseDialog}
      onConfirm={onConfirm}
      title={t('create-email-dialog.title')}
      loading={loading}
    >
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <TextField
            variant="standard"
            required
            error={error === 'email_required'}
            helperText={t('common.required')}
            id="email"
            label={t('create-email-dialog.email')}
            fullWidth
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}
